import React, { useState, useEffect } from "react";
import login from "./login.module.css";
import { useForm } from "react-hook-form";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { CiLock, CiMail, CiMobile3 } from "react-icons/ci";
import { IoEye, IoEyeOff } from "react-icons/io5";
import OTPInput from "react-otp-input";
import { SuccessSwal, warningSwal } from "../../Util/Toast";
import {
    loginUser,
    generateOtp,
    verifyOtp,
    registerGoogle,
} from "../../Services/APIrequests";
import ApiService from "../../Services/config";
import { FaSpinner } from "react-icons/fa";
import { GoogleLogin } from "@react-oauth/google";

const Login = () => {
    const Navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [hidePassword, setHidePassword] = useState(true);
    const [type, setType] = useState("EmailPassword");
    const [resendDisabled, setResendDisabled] = useState(false);
    const [timer, setTimer] = useState(0);
    const [otp, setOtp] = useState("");
    const [userMobile, setUserMobile] = useState("");

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    // Check if the user is already logged in on page load
    useEffect(() => {
        const token = sessionStorage.getItem("token");
        if (token) {
            ApiService.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${token}`;
            Navigate("/BusinessesforSale");
        }
    }, [Navigate]);

    const handleLogin = (data) => {
        setLoading(true);
        if (type === "MobileNumber") {
            verifyMobile(data);
        } else if (type === "OTP") {
            VerifyOtp(data);
        } else {
            loginUserAPI(data, Navigate);
        }
    };

    const handleResend = (data) => {
        if (type === "OTP") {
            verifyMobile(data);
        }
    };
    console.log(location.state);
    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            setLoading(true);
            const idToken = credentialResponse?.credential;
            if (!idToken) {
                warningSwal("Error", "Google login failed");
                return;
            }

            const res = await registerGoogle({ idToken });
            let redirect = location.state.from || "/BusinessesforSale";
            if (res.status === 200) {
                SuccessSwal("Welcome back!", "Logged in successfully!");
                sessionStorage.setItem("token", res.data.token);
                ApiService.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${res.data.token}`;
                Navigate(redirect);
            } else if (res.status === 201) {
                SuccessSwal("Success", "Registered with Google successfully!");
                sessionStorage.setItem("token", res.data.token);
                ApiService.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${res.data.token}`;
                Navigate(redirect);
            } else {
                warningSwal("Error", res.data.message);
            }
        } catch (err) {
            warningSwal(
                "Error",
                err.response?.data?.message || "Google authentication failed"
            );
        } finally {
            setLoading(false);
        }
    };

    const verifyMobile = async (data) => {
        try {
            setUserMobile(data.mobileNumber);
            const newUser = 0;

            const response = await generateOtp({
                phone: data.mobileNumber,
                newUser: newUser,
            });
            if (response) {
                setResendDisabled(true);
                startResendTimer();
                setTimer(30);
                setType("OTP");
                SuccessSwal(
                    "OTP generated successfully",
                    response.data.message
                );
            } else {
                warningSwal("Failed to generate OTP", response.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error generating OTP",
                error.response?.data?.message || "Something went wrong"
            );
            console.error("Error generating OTP", error);
        } finally {
            setLoading(false);
        }
    };

    const startResendTimer = () => {
        const intervalId = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer === 1) {
                    clearInterval(intervalId);
                    setResendDisabled(false);
                }
                return prevTimer - 1;
            });
        }, 1000);
    };

    const VerifyOtp = async (data) => {
        try {
            const newUser = 0;
            const response = await verifyOtp({
                phone: userMobile,
                otp,
                newUser,
            });
            let redirect = location.state?.from || "/BusinessesforSale";
            if (response) {
                ApiService.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${response?.data?.token}`;
                sessionStorage.setItem("token", response.data.token);
                SuccessSwal("Success", "OTP verified successfully!");

                Navigate(redirect);
            } else {
                warningSwal("Failed to verify OTP", response.data.message);
            }
        } catch (error) {
            warningSwal(
                "Error verifying OTP",
                error.response?.data?.message || "Something went wrong"
            );
            console.error("Error verifying OTP", error);
        } finally {
            setLoading(false);
        }
    };

    const loginUserAPI = async (data, Navigate) => {
        try {
            const response = await loginUser(data);
            if (response?.data?.token) {
                ApiService.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${response?.data?.token}`;
                sessionStorage.setItem("token", response.data.token);
                SuccessSwal("Success", "Login Successfully");
                const redirectUrl = sessionStorage.getItem("redirectUrl");
                sessionStorage.removeItem("redirectUrl");
                let redirect = location.state?.from || "/BusinessesforSale";
                const finalUrl =
                    redirectUrl && redirectUrl !== "/"
                        ? redirectUrl
                        : "/BusinessesforSale";
                Navigate(redirect);
            } else if (response?.data?.message) {
                warningSwal("Error", response.data.message);
            } else {
                console.log("Login failed", response);
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                warningSwal("Error", error.response.data.message);
            } else {
                warningSwal(
                    "Error",
                    "An unexpected error occurred. Please try again."
                );
            }
            console.error("Login error", error);
        } finally {
            setLoading(false);
        }
    };

    const handleType = () => {
        setType(type === "MobileNumber" ? "EmailPassword" : "MobileNumber");
        setValue("password", "");
        setValue("mobileNumber", "");
        setValue("mail", "");
        setOtp("");
    };

    return (
        <div className={login.Comman_Container}>
            <div className={login.bgcontainer}>
                <div className={login.header_section}>
                    {type === "OTP" ? (
                        <>
                            <h1 className={login.header_text}>Verify</h1>
                            <p className={login.subheader_text}>
                                Enter verification code
                            </p>
                        </>
                    ) : (
                        <>
                            <h1 className={login.header_text}>Login</h1>
                            <p className={login.subheader_text}>Welcome Back</p>
                        </>
                    )}
                </div>

                {/* Google Login Section - Only show for non-OTP types */}
                {type !== "OTP" && (
                    <div className={login.google_section}>
                        <div className={login.divider}>
                            <span>Sign in with Google</span>
                        </div>
                        <div className={login.google_login_wrapper}>
                            <GoogleLogin
                                onSuccess={handleGoogleSuccess}
                                onError={() =>
                                    warningSwal(
                                        "Error",
                                        "Google authentication failed"
                                    )
                                }
                                size="large"
                                theme="outline"
                                text="signin_with"
                                shape="rectangular"
                                width="100%"
                            />
                        </div>
                        <div className={login.divider}>
                            <span>
                                Or continue with{" "}
                                {type === "EmailPassword" ? "email" : "phone"}
                            </span>
                        </div>
                    </div>
                )}

                <div className={login.form_section}>
                    <form onSubmit={handleSubmit(handleLogin)}>
                        {type === "EmailPassword" && (
                            <>
                                <div className={login["form-control"]}>
                                    <label htmlFor="email">Email Address</label>
                                    <div className={login.input_container}>
                                        <input
                                            type="email"
                                            placeholder="Enter your email address"
                                            {...register("mail", {
                                                required: "Email is required!",
                                                pattern: {
                                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                    message:
                                                        "Enter a valid email address!",
                                                },
                                            })}
                                            disabled={loading}
                                        />
                                        <CiMail
                                            className={login.icon}
                                            size={22}
                                        />
                                    </div>
                                    {errors?.mail && (
                                        <p className={login.error}>
                                            {errors?.mail?.message}
                                        </p>
                                    )}
                                </div>

                                <div className={login["form-control"]}>
                                    <label htmlFor="password">Password</label>
                                    <div className={login.input_container}>
                                        <input
                                            type={
                                                hidePassword
                                                    ? "password"
                                                    : "text"
                                            }
                                            placeholder="Enter your password"
                                            {...register("password", {
                                                required:
                                                    "Password is required!",
                                                minLength: {
                                                    value: 6,
                                                    message:
                                                        "Password must be at least 6 characters long!",
                                                },
                                            })}
                                            disabled={loading}
                                        />
                                        {/* <CiLock className={login.icon} size={22} /> */}
                                        <button
                                            type="button"
                                            className={login.picons}
                                            onClick={() =>
                                                setHidePassword(!hidePassword)
                                            }>
                                            {hidePassword ? (
                                                <IoEye />
                                            ) : (
                                                <IoEyeOff />
                                            )}
                                        </button>
                                    </div>
                                    {errors?.password && (
                                        <p className={login.error}>
                                            {errors?.password?.message}
                                        </p>
                                    )}
                                </div>

                                <p
                                    className={login.swipetext}
                                    onClick={() => Navigate("/forgetPassword")}>
                                    Forgot password?
                                </p>

                                <button
                                    type="submit"
                                    className={login.submit_btn}
                                    disabled={loading}>
                                    {loading ? (
                                        <>
                                            <FaSpinner
                                                className={login.spinner}
                                            />
                                            Logging in...
                                        </>
                                    ) : (
                                        "Log In"
                                    )}
                                </button>
                            </>
                        )}

                        {type === "MobileNumber" && (
                            <>
                                <div className={login["form-control"]}>
                                    <label htmlFor="mobileNumber">
                                        Mobile Number
                                    </label>
                                    <div className={login.input_container}>
                                        <input
                                            type="tel"
                                            placeholder="Enter your mobile number"
                                            {...register("mobileNumber", {
                                                required:
                                                    "Mobile number is required!",
                                                pattern: {
                                                    value: /^[6-9]\d{9}$/,
                                                    message:
                                                        "Enter a valid 10-digit mobile number",
                                                },
                                            })}
                                            disabled={loading}
                                        />
                                        <CiMobile3
                                            className={login.icon}
                                            size={22}
                                        />
                                    </div>
                                    {errors?.mobileNumber && (
                                        <p className={login.error}>
                                            {errors?.mobileNumber?.message}
                                        </p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className={login.submit_btn}
                                    disabled={loading}>
                                    {loading ? (
                                        <>
                                            <FaSpinner
                                                className={login.spinner}
                                            />
                                            Sending OTP...
                                        </>
                                    ) : (
                                        "Send OTP"
                                    )}
                                </button>
                            </>
                        )}

                        {type === "OTP" && (
                            <>
                                <div className={login["form-control"]}>
                                    <label htmlFor="Otp">
                                        Enter Verification Code
                                    </label>
                                    <div className={login.otp_description}>
                                        <p>
                                            We have sent an SMS verification
                                            code to:
                                            <br />
                                            <span
                                                className={login.phone_masked}>
                                                {userMobile
                                                    ? userMobile.replace(
                                                          /^(\d{3})(\d{3})(\d{2})(\d{2})$/,
                                                          "$1 XXX XX $4"
                                                      )
                                                    : "XXX XXX XX XX"}
                                            </span>
                                        </p>
                                    </div>

                                    <div className={login.otp_input_wrapper}>
                                        <OTPInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={4}
                                            inputType={"tel"}
                                            shouldAutoFocus={true}
                                            containerStyle={
                                                login["otp-input-container"]
                                            }
                                            renderInput={(props) => (
                                                <input
                                                    {...props}
                                                    className={login.otpInput}
                                                />
                                            )}
                                        />
                                    </div>
                                    {errors?.Otp && (
                                        <p className={login.error}>
                                            {errors?.Otp?.message}
                                        </p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className={login.verify_btn}
                                    disabled={loading || otp.length !== 4}>
                                    {loading ? (
                                        <>
                                            <FaSpinner
                                                className={login.spinner}
                                            />
                                            Verifying...
                                        </>
                                    ) : (
                                        "Verify OTP"
                                    )}
                                </button>

                                <button
                                    type="button"
                                    className={login.resend_btn}
                                    disabled={resendDisabled || loading}
                                    onClick={() =>
                                        handleSubmit(handleResend)()
                                    }>
                                    {resendDisabled
                                        ? `Resend OTP (${timer}s)`
                                        : "Resend OTP"}
                                </button>

                                <button
                                    type="button"
                                    className={login.back_btn}
                                    onClick={() => {
                                        setType("MobileNumber");
                                        setOtp("");
                                        setUserMobile("");
                                    }}>
                                    Back to Mobile Number
                                </button>
                            </>
                        )}
                    </form>
                </div>

                {/* Login Type Switch */}
                {type !== "OTP" && (
                    <div className={login.footer_section}>
                        <p className={login.footer_text} onClick={handleType}>
                            {type === "MobileNumber"
                                ? "Login with Email?"
                                : "Login with Mobile Number?"}
                        </p>
                    </div>
                )}

                {/* Register Link */}
                <div className={login.bottom_textcontainer}>
                    <p className={login.conetnt_text}>
                        Don't have an account?{" "}
                        <NavLink to="/signup" className={login.register_link}>
                            Register
                        </NavLink>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
